import React from 'react'
import type { Icon } from 'shared/utils'

const CameraPlus = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'camera-plus',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M19.273 10.273a.91.91 0 00-.91.909v6.363a.91.91 0 01-.908.91H4.727a.91.91 0 01-.909-.91v-7.272a.91.91 0 01.91-.91h1.817a.91.91 0 00.91-.618l.49-1.49a.91.91 0 01.864-.619h5.01a.91.91 0 100-1.818H8.763a2.727 2.727 0 00-2.582 1.864l-.291.909H4.727A2.727 2.727 0 002 10.318v7.273a2.727 2.727 0 002.727 2.727h12.728a2.727 2.727 0 002.727-2.727v-6.364a.91.91 0 00-.91-.954zm-8.182-.91a3.636 3.636 0 100 7.273 3.636 3.636 0 000-7.272zm0 5.455a1.818 1.818 0 110-3.636 1.818 1.818 0 010 3.636zm10-10h-.91V3.91a.91.91 0 10-1.817 0v.91h-.91a.91.91 0 000 1.817h.91v.91a.91.91 0 001.818 0v-.91h.909a.91.91 0 000-1.818z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    )
}

export { CameraPlus }
